import React from "react";
import "./SWUpdate.css";

export default props => (
  <div className={"SWUpdate"}>
    A new version of the app is available.
  </div>
);
